import React from "react";

import classes from "./ExportLayoutSelect.module.css";
import { OUTPUT_AUDIO_LAYOUT_OPTIONS } from "./audioLayout.js";

// Audio layout picker shown next to a version name when exporting. The hint
// is static: the dashboard doesn't know the stems' channel counts, so it
// can't tell whether a forced 5.1 export will be true surround.
const ExportLayoutSelect = ({ id, value, onChange, disabled = false, className = "" }) => {
    const hintId = `${id}-hint`;
    const showSurroundHint = value === "5.1";

    return (
        <div className={`${classes["ExportLayout"]} ${className}`}>
            <label className={classes["ExportLayoutLabel"]} htmlFor={id}>
                Audio layout
            </label>
            <select
                id={id}
                className={classes["ExportLayoutSelect"]}
                value={value}
                disabled={disabled}
                aria-describedby={showSurroundHint ? hintId : undefined}
                onChange={(event) => onChange(event.target.value)}
            >
                {OUTPUT_AUDIO_LAYOUT_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            {showSurroundHint && (
                <p id={hintId} className={classes["ExportLayoutHint"]}>
                    Stereo music/effects stems are placed in front left/right only. Supply 5.1
                    stems for true surround.
                </p>
            )}
        </div>
    );
};

export default ExportLayoutSelect;
